import * as angular from "angular";
import {QuickFilterContextService} from "../commons/services/quick-filter-context.service";
import {SurveyRequests} from "./services/survey-requests.service";
import {DateRangeTimeFiltersService} from "../commons/services/date-range-time-filters.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {CommonsService} from "../commons/services/commons-service.service";

angular
  .module('bringoz.admin.survey')
  .config(surveyConfig);

/* @ngInject */
function surveyConfig($stateProvider, moment) {

  $stateProvider
    .state('survey', {
      parent: 'bringoz.site',
      url: '/survey',
      template: '<ui-view></ui-view>',
      abstract: true
    })
    .state('survey.details', {
      url: '/details?:from?:to&:dateRangeTemplateType&:surveyScore&:branchIds&:accountIds&:agentIds&:supplyAccountIds',
      reloadOnSearch: false,
      controllerAs: 'vm',
      template: '<survey-details from="vm.from" to="vm.to" type="vm.type" branch-ids="vm.branchIds" ' +
        'selected-quick-filter-id="vm.selectedQuickFilterId" date-range-template-type="vm.dateRangeTemplateType" survey-score="vm.surveyScore" account-ids="vm.accountIds" ' +
        'agent-ids="vm.agentIds" supply-account-ids="vm.supplyAccountIds"></survey-details>',
      controller: function ($scope, triBreadcrumbsService, $stateParams, quickFilterContextService: QuickFilterContextService,
                            commonsService: CommonsService, types, google, dateRangeTimeFiltersService: DateRangeTimeFiltersService, viewFilterSettingsService: ViewFilterSettingsService, $state, site) {
        this.type = types[0];
        // this.reviews = reviews;
        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        this.selectedQuickFilterId = quickActiveFilter?.id;

        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType;
        if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        } else {
          this.from = $stateParams.from ? parseInt($stateParams.from) : undefined;
          this.to = $stateParams.to ? parseInt($stateParams.to) : undefined;
        }

        this.branchIds = $stateParams.branchIds ? commonsService.parseArrayStateParam($stateParams.branchIds) : [];
        this.accountIds = $stateParams.accountIds ? commonsService.parseArrayStateParam($stateParams.accountIds) : [];
        this.agentIds = $stateParams.agentIds ? commonsService.parseArrayStateParam($stateParams.agentIds) : [];
        this.supplyAccountIds = $stateParams.supplyAccountIds ? commonsService.parseArrayStateParam($stateParams.supplyAccountIds) : [];
        this.surveyScore = $stateParams.surveyScore;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Survey"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        types: function (surveyRequests: SurveyRequests, site) {
          return surveyRequests.getTypes();
        },
        google: ['googleChartApiPromise', function (googleChartApiPromise) {
          return googleChartApiPromise;
        }]
      }
    })
}
